<ui-dialog
    [open]="isDeleteDialogOpen"
    (closing)="closeDeleteDialog()"
    header="performance.templateIndex.deleteDialog.header"
    size="small"
>
    <p>{{ 'performance.templateIndex.deleteDialog.message' | translate }}</p>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeDeleteDialog()">{{ 'cancel' | translate }}</ui-button>
        <ui-button type="danger" (click)="onDelete()">{{ 'delete' | translate }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<app-deprecated-modal-form
    #templateModal
    [form]="templateForm"
    (save)="onCreate()"
    headerText="surveys.templates.index.createTemplate"
>
    <app-form-template [template]="template" #templateForm></app-form-template>
</app-deprecated-modal-form>

<div class="page-container no-scroll">
    <app-header title="surveys.templates.index.title" [menuService]="menuService">
        <div class="buttons">
            <ui-button type="primary" *ngIf="canCreate | async" (click)="templateModal.show()">
                <mat-icon svgIcon="plus"></mat-icon>
                {{ 'surveys.templates.index.createTemplate' | translate }}
            </ui-button>
        </div>
    </app-header>

    <ui-card class="scrollable-table-container" [withMargin]="false" [withSpacing]="false">
        <app-table
            [table]="table"
            (menuItemSelected)="menuAction($event)"
            [isResponsive]="true"
            [showOffset]="true"
            [noPadding]="true"
            [embedded]="true"
        >
            <app-empty-state
                label="surveys.templates.index.noTemplatesFound"
                src="/assets/illustrations/clipboard-star.png"
            ></app-empty-state>
        </app-table>
    </ui-card>
</div>
